<div class="signupwrapper">
  <img class="logo" [src]="logoUrl">
  <mat-card class="signup-card">
    <mat-card-title>{{signUpTitle}}</mat-card-title>
    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="signUpClicked()">
        <div>
          <p>
            <mat-form-field>
              <input type="text" matInput placeholder="Email" formControlName="username">
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-label>Brand</mat-label>
              <mat-select formControlName="brand">
                @for (partnerOption of partners; track partnerOption) {
                  <mat-option [value]="partnerOption.partnerId">
                    {{ getPartnerLabel(partnerOption) }}
                  </mat-option>
                }
              </mat-select>
              @if (brandContextLoading) {
                <mat-hint>Checking invite</mat-hint>
              }
              @if (!brandContextLoading && inviteDerivedBrand) {
                <mat-hint>Matched invite</mat-hint>
              }
              @if (form.get('brand')?.hasError('required')) {
                <mat-error>Brand is required.</mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Password" formControlName="password">
              <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                <mat-icon class="hide-password-icon" [svgIcon]="hidePassword ? 'icon-eye-lock' : 'icon-eye'"></mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field>
              <input [type]="hidePassword ? 'password' : 'text'" matInput placeholder="Confirm Password" formControlName="confirmPassword">
            </mat-form-field>
          </p>
        </div>
        @if (error) {
          <p class="error">
            {{ error }}
          </p>
        }
        <div class="button">
          <button
            type="submit"
            color="primary"
            mat-raised-button
            [disabled]="partnersLoading || brandContextLoading || isSignupSubmitting"
            >
            @if (isSignupSubmitting) {
              <mat-spinner class="signup-button-spinner" [diameter]="18"></mat-spinner>
            }
            <span>{{ isSignupSubmitting ? 'Signing up...' : 'Sign up' }}</span>
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <a class="login-w-passwd" href="/login">Login</a>
  <div class="footer-copy">
    @if (isPayrollAdmin) {
      <span class="powered-by">Powered by Wallit</span>
    }
    <span class="version" [class.version-with-powered-by]="isPayrollAdmin">Version {{info}}</span>
  </div>
</div>
